// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__1tE18","container":"style_container__3AsTd","main":"style_main__393_p"};